import React, { FC, SyntheticEvent } from 'react';
import { ReactComponent as MobileMenuIconOpen } from '../../../assets/icons/mobiler-menu-icon-open.svg';
import { ReactComponent as MobileMenuIconClose } from '../../../assets/icons/mobiler-menu-icon-close.svg';

interface IProps {
  isOpen: boolean;
  toggleMenu: (event: SyntheticEvent<HTMLAnchorElement | HTMLDivElement | HTMLUListElement>) => void;
}

const MobileMenuIcon: FC<IProps> = ({ isOpen, toggleMenu }): JSX.Element => {
  return (
    <a className="menu" href="#" onClick={toggleMenu}>
      {isOpen
        ? <MobileMenuIconClose className="mobile-menu-icon-close"/>
        : <MobileMenuIconOpen className="mobile-menu-icon-open"/>
      }
    </a>
  );
};

export default MobileMenuIcon;